import {
	HubConnection,
	HubConnectionBuilder,
	HubConnectionState,
	LogLevel,
} from "@microsoft/signalr";

type ReceiveMessageHandler = (author: string, message: string) => void;

const receiveMessageHandlers = new Set<ReceiveMessageHandler>();

let connection: HubConnection | null = null;
let startPromise: Promise<void> | null = null;

const getConnection = () => {
	if (connection) return connection;

	connection = new HubConnectionBuilder()
		.withUrl("/ws")
		.withAutomaticReconnect()
		.configureLogging(LogLevel.Information)
		.build();

	connection.on("ReceiveMessage", (author: string, message: string) => {
		receiveMessageHandlers.forEach((handler) => {
			handler(author, message);
		});
	});

	connection.onclose((error) => {
		if (error) console.log("SignalR connection closed", error);
	});

	return connection;
};

const startConnection = () => {
	const currentConnection = getConnection();

	if (currentConnection.state !== HubConnectionState.Disconnected) {
		return Promise.resolve();
	}

	if (startPromise) return startPromise;

	startPromise = currentConnection
		.start()
		.then(() => {
			console.log("SignalR connection started");
		})
		.catch((err) => {
			console.log("Error while starting SignalR connection: " + err);
		})
		.finally(() => {
			startPromise = null;
		});

	return startPromise;
};

export const subscribeMesfRealtime = (handler: ReceiveMessageHandler) => {
	receiveMessageHandlers.add(handler);
	void startConnection();

	return () => {
		receiveMessageHandlers.delete(handler);
	};
};
